export default __webpack_public_path__ + "e21c71683be8f5aeee077e7eea5bae52.svg";